import { SET_TAP_TO_PAY_TIPS } from '../../actionTypes/tap2Pay'

const initialState = {
	tap2PayTips: 0,
}

export function tap2PayReducer (state = initialState, action) {
	switch (action.type) {
		case SET_TAP_TO_PAY_TIPS:
			return {
				...state,
				tap2PayTips: action.value,
			}
		default:
			return state
	}
}
